import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: 
		{
			title: 'หน้าหลัก',
			type: 'page',
			auth: false,
		},
	},
	{
		path: '/member',
		name: 'Member',
		component: () => import('../views/Member.vue'),
		meta: 
		{
			title: 'สมาชิก',
			type: 'page',
			auth: true,
		},
	},
	{
		path: '/member/login',
		name: 'Login',
		component: () => import('../views/Login.vue'),
		meta: 
		{
			title: 'เข้าสู่ระบบ',
			type: 'page',
			auth: false,
		},
	},
	{
		path: '/member/register',
		name: 'Register',
		component: () => import('../views/Register.vue'),
		meta: 
		{
			title: 'ลงทะเบียน',
			type: 'page',
			auth: false,
		},
	},
	{
		path: '/about',
		name: 'About',
		component: () => import('../views/About.vue'),
		meta: 
		{
			title: 'เกี่ยวกับเรา',
			type: 'page',
			auth: false,
		},
	},
	{
		path: '/faq',
		name: 'FAQ',
		component: () => import('../views/Faq.vue'),
		meta: 
		{
			title: 'คำถามที่พบบ่อย',
			type: 'page',
			auth: false,
		},
	},
	{
		path: '/plan',
		name: 'Plan',
		component: () => import('../views/Plan.vue'),
		meta: 
		{
			title: 'แผนฝึกอบรม',
			type: 'page',
			auth: false,
		},
	},
	{
		path: '/course',
		component: '',
		children: [
		{
			name: 'Course',
			path: '',
			meta: 
			{
				title: 'หลักสูตร',
				type: 'page',
				auth: false,
			},
			component: () => import('../views/Course.vue'),
		},
		{
			name: 'Detail',
			path: 'detail/:id',
			meta: 
			{
				title: 'รายละเอียด',
				type: 'page',
				auth: false,
			},
			component: () => import('../views/CourseDetail.vue'),
		}, 
		{
			name: 'Play',
			path: 'play/:id/:ep',
			meta: 
			{
				title: 'เข้าเรียน',
				type: 'page',
				auth: true,
			},
			component: () => import('../views/CoursePlay.vue'),
		}, 
		{
			name: 'Exam',
			path: 'exam/:id',
			meta: 
			{
				title: 'แบบทดสอบ',
				type: 'page',
				auth: false,
			},
			component: () => import('../views/Contact.vue'),
		}]
	},
	{
		path: '/projects',
		name: 'Projects',
		component: () => import('../views/Projects.vue'),
		meta: 
		{
			title: 'โครงการ',
			type: 'page',
			auth: true,
		},
	},
	{
		path: '/projects/single-project',
		name: 'Single Project',
		component: () => import('../views/SingleProject.vue'),
		meta: 
		{
			title: 'รายละเอียด',
			parent: 'โครงการ',
			type: 'post',
			auth: true,
		},
	},
	{
		path: '/contact',
		name: 'Contact',
		component: () => import('../views/Contact.vue'),
		meta: 
		{
			title: 'ติดต่อเรา',
			type: 'page',
			auth: false,
		},
	},
	{
		path: '/starter',
		name: 'Starter',
		component: () => import('../views/Starter.vue'),
		meta: 
		{
			title: 'starter',
			type: 'page',
			auth: false,
		},
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior() {
		document.getElementById('app').scrollIntoView();
	},
});

export default router;

/**
 * Below code will display the component/active page title
 * Powered by: Leng Chhinghor
 */

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
	// This goes through the matched routes from last to first, finding the closest route with a title.
	// e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
	// `/nested`'s will be chosen.
	const nearestWithTitle = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.title);

	// Find the nearest route element with meta tags.
	const nearestWithMeta = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	const previousNearestWithMeta = from.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	// If a route with a title was found, set the document (page) title to that value.
	if (nearestWithTitle) {
		document.title = nearestWithTitle.meta.title;
	} else if (previousNearestWithMeta) {
		document.title = previousNearestWithMeta.meta.title;
	}

	// Remove any stale meta tags from the document using the key attribute we set below.
	Array.from(
		document.querySelectorAll('[data-vue-router-controlled]')
	).map((el) => el.parentNode.removeChild(el));

	// Skip rendering meta tags if there are none.
	if (!nearestWithMeta) return next();

	// Turn the meta tag definitions into actual elements in the head.
	nearestWithMeta.meta.metaTags
		.map((tagDef) => {
			const tag = document.createElement('meta');

			Object.keys(tagDef).forEach((key) => {
				tag.setAttribute(key, tagDef[key]);
			});

			// We use this to track which meta tags we create so we don't interfere with other ones.
			tag.setAttribute('data-vue-router-controlled', '');

			return tag;
		})
		// Add the meta tags to the document head.
		.forEach((tag) => document.head.appendChild(tag));

	next();
});
